'use client';

import { ReactNode } from 'react';
import { Skeleton } from '@mui/material';
import { cn } from '@/lib/utils';

interface ListWithSkeletonProps<T> {
  loading: boolean;
  list: T[];
  itemRender: (item: T, index: number) => ReactNode;
  skeletonHolder?: ReactNode;
  wrapperClassName?: string;
}
export default function ListWithSkeleton<T>(props: ListWithSkeletonProps<T>) {
  const { loading, list, itemRender, skeletonHolder, wrapperClassName } = props;

  if (loading) {
    return (
      skeletonHolder || (
        <div className={wrapperClassName}>
          {[...Array(6)].map((_, index) => (
            <LoadingHolder key={index} />
          ))}
        </div>
      )
    );
  }

  return (
    <div className={wrapperClassName}>{list.map((item, index) => itemRender(item, index))}</div>
  );
}

function LoadingHolder() {
  return (
    <div
      className={cn(
        'rounded-lg overflow-hidden w-full hover:opacity-90 transition-opacity',
        'py-4 px-3 space-y-3 hover:text-[#b7b9bc]',
        'bg-[#121212] border border-[#1F1F1F]',
      )}
    >
      {/* 头部：头像和标题信息 */}
      <div className="flex items-center gap-2.5">
        <Skeleton
          variant="rectangular"
          width={40}
          height={40}
          className="rounded-sm"
          sx={{ bgcolor: 'grey.800' }}
        />

        <div className="flex-1">
          <Skeleton
            variant="text"
            height={20}
            className="rounded-sm"
            sx={{ fontSize: '1rem', bgcolor: 'grey.800' }}
          />
          <Skeleton
            variant="text"
            height={20}
            className="rounded-sm flex-1"
            sx={{ fontSize: '1rem', bgcolor: 'grey.800' }}
          />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <Skeleton
          variant="text"
          height={20}
          className="rounded-sm flex-1"
          sx={{ fontSize: '1rem', bgcolor: 'grey.800' }}
        />
        <Skeleton
          variant="text"
          height={20}
          className="rounded-sm flex-1"
          sx={{ fontSize: '1rem', bgcolor: 'grey.800' }}
        />
        <Skeleton
          variant="text"
          height={20}
          className="rounded-sm flex-1"
          sx={{ fontSize: '1rem', bgcolor: 'grey.800' }}
        />
      </div>
    </div>
  );
}
